import { MemberDependent } from '@interfaces/member-dependent.model';

export type ActiveMemberState = {
  memberCount: number;
  activeMember: MemberDependent;
};

export const initialState: ActiveMemberState = {
  memberCount: 0,
  activeMember: new MemberDependent({}),
};
